// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3HppY","content":"ManualTimeModal_content__2qbun"};